export default __webpack_public_path__ + "static/media/phenotype.71a912ad.png";